<template>
  <div>
    <Menu />
    <header class="hero hero-sell">
      <div class="container">
        <div class="hero-topbar d-flex align-items-center justify-content-between">

          <div class="brand-lockup">
            <a href="/home" class="d-flex align-items-center text-decoration-none">
              <img src="https://www.stratitude.co.za/chas-international/dubai/images/chas-logo.svg" alt="Chas Everitt" class="brand-logo" loading="lazy" />
            </a>

            <span class="brand-divider d-none d-md-inline-block" aria-hidden="true"></span>

            <div class="d-none d-md-block">
              <a href="https://www.leadingre.com/" class="d-flex align-items-center text-decoration-none" target="_blank" rel="noopener noreferrer">
                <img src="https://www.stratitude.co.za/chas-international/dubai/images/leading-logo1.png" alt="Leading Real Estate" class="partner-logo" loading="lazy" />
              </a>
            </div>
          </div>

          <!-- Desktop nav -->
          <nav class="d-none d-lg-flex hero-nav align-items-center">
            <a class="nav-link" href="/properties">Buy</a>
            <a class="nav-link" href="sell">Sell</a>
            <a class="nav-link" href="/developments" aria-current="page">Developments</a>
            <a class="nav-link" href="/commercial" aria-current="page">Commercial</a>
          </nav>

          <!-- Mobile hamburger -->
          <button class="btn hamburger d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileNav">
            <i class="bi bi-list" style="font-size:1.25rem;"></i>
          </button>

        </div>

        <div class="pt-5 pb-4">
          <h1 class="hero-title mb-3"><strong>Sell</strong></br> Your Property</h1>

          <!-- <div class="d-flex hero-tabs">
          <a href="#" class="active">Dubai</a>
          <a href="https://www.chaseveritt.co.zw/">Zimbabwe</a>
          <a href="#">Mauritius</a>
          <a href="https://www.chaseveritt.co.za/">South Africa</a>
        </div> -->

        </div>

      </div>
    </header>


    <!-- INTRO -->
    <section class="py-5 bg-white">
      <div class="container">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-6">
            <div class="section-title">Why Sell With Chas Everitt Dubai</div>
            <div class="section-rule"></div>

            <p class="mb-3">
              We combine local market knowledge, international reach, and a trusted brand to position
              your property for the right buyers.
            </p>

            <p class="mb-3">
              From pricing strategy and listing presentation to marketing exposure and buyer management,
              our team is here to guide the process from start to finish.
            </p>

            <p class="mb-0">
              Whether you are selling a luxury apartment, villa, investment unit, or commercial asset,
              we work to maximise value and reduce friction throughout the transaction.
            </p>
          </div>

          <div class="col-12 col-lg-6">
            <div class="sell-image-card">
              <img src="https://www.stratitude.co.za/chas-international/dubai/images/selling-your-prop.png" alt="Sell property with Chas Everitt Dubai" class="img-fluid w-100" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- VALUE POINTS -->
    <section class="why-buy">
      <div class="container">
        <div class="section-title text-center">What You Can Expect</div>
        <div class="section-rule"></div>

        <div class="row g-3 justify-content-center">
          <div class="col-6 col-md-3">
            <div class="why-item">
              <div class="why-icon"><i class="bi bi-bar-chart-line"></i></div>
              <div class="why-label">Accurate Pricing</div>
            </div>
          </div>

          <div class="col-6 col-md-3">
            <div class="why-item">
              <div class="why-icon"><i class="bi bi-megaphone"></i></div>
              <div class="why-label">Targeted Marketing</div>
            </div>
          </div>

          <div class="col-6 col-md-3">
            <div class="why-item">
              <div class="why-icon"><i class="bi bi-people"></i></div>
              <div class="why-label">Qualified Buyers</div>
            </div>
          </div>

          <div class="col-6 col-md-3">
            <div class="why-item">
              <div class="why-icon"><i class="bi bi-house-check"></i></div>
              <div class="why-label">End-To-End Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FORM -->
    <section class="contact-block">
      <div class="container">
        <div class="row g-4 align-items-start">
          <div class="col-12 col-lg-5">
            <div class="section-title">Request a Property Valuation</div>
            <div class="section-rule"></div>

            <p class="mb-3">
              Tell us a bit about your property and our team will get in touch to discuss the next steps.
            </p>

            <p class="mb-0">
              We can assist with residential, investment, and commercial sales in Dubai.
            </p>
          </div>

          <div class="col-12 col-lg-7">
            <form class="sell-form" @submit.prevent="submitForm">
              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <input v-model="form.name" type="text" class="form-control" placeholder="Full Name" />
                </div>

                <div class="col-12 col-md-6">
                  <input v-model="form.email" type="email" class="form-control" placeholder="Email Address" />
                </div>

                <div class="col-12 col-md-6">
                  <input v-model="form.phone" type="text" class="form-control" placeholder="Phone Number" />
                </div>

                <div class="col-12 col-md-6">
                  <input v-model="form.location" type="text" class="form-control" placeholder="Property Location" />
                </div>

                <div class="col-12 col-md-6">
                  <select v-model="form.propertyType" class="form-select">
                    <option value="">Property Type</option>
                    <option value="Apartment">Apartment</option>
                    <option value="Villa">Villa</option>
                    <option value="Townhouse">Townhouse</option>
                    <option value="Commercial">Commercial</option>
                  </select>
                </div>

                <div class="col-12 col-md-6">
                  <input v-model="form.priceExpectation" type="text" class="form-control" placeholder="Expected Price" />
                </div>

                <div class="col-12">
                  <textarea v-model="form.message" class="form-control" rows="6" placeholder="Tell us more about your property"></textarea>
                </div>

                <div class="col-12">
                  <button class="btn btn-brand" type="submit" :disabled="sending">
                  <span v-if="sending">Submitting...</span>
                  <span v-else>Submit Enquiry</span>
                </button>
                </div>

                <div class="col-12" v-if="errorMessage">
                    <p class="mb-0 text-danger">{{ errorMessage }}</p>
                  </div>

                <div class="col-12" v-if="submitted">
                  <p class="mb-0 text-success">Thank you. Your enquiry has been submitted.</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="join-band">
      <div class="container">
        <div class="row align-items-center g-3">
          <div class="col-12 col-lg-9">
            <h4>Ready to sell? Let our team position your property properly.</h4>
          </div>
          <div class="col-12 col-lg-3 text-lg-end">
            <a class="btn btn-danger" href="/properties">Browse Properties</a>
          </div>
        </div>
      </div>
    </section>

    <!-- Mobile Offcanvas Nav -->
    <div class="offcanvas offcanvas-end offcanvas-custom" tabindex="-1" id="mobileNav" aria-labelledby="mobileNavLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title text-white" id="mobileNavLabel">Menu</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body">
        <div class="list-group list-group-flush">
          <a class="list-group-item list-group-item-action" href="/properties">Buy</a>
          <a class="list-group-item list-group-item-action" href="/sell">Sell</a>
          <a class="list-group-item list-group-item-action" href="/developments">Developments</a>
          <a class="list-group-item list-group-item-action" href="/commercial">Commercial</a>
        </div>
        <hr />
      </div>
    </div>

    <div class="mt-4"></div>
    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Menu, Footer
  },

  data() {
    return {
      submitted: false,
      sending: false,
      errorMessage: '',
      form: {
        name: '',
        email: '',
        phone: '',
        location: '',
        propertyType: '',
        priceExpectation: '',
        message: ''
      }
    }
  },

  methods: {
  async submitForm() {
  this.submitted = false
  this.errorMessage = ''
  this.sending = true

  try {
    const response = await axios.post('https://stratitude.co.za/api/agentForm-dubai.php', {
      name: this.form.name,
      email: this.form.email,
      phone: this.form.phone,
      location: this.form.location,
      propertyType: this.form.propertyType,
      priceExpectation: this.form.priceExpectation,
      message: this.form.message,
      source: 'Chas Dubai Sell Form'
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })

    console.log(response.data)

    this.submitted = true

    this.form = {
      name: '',
      email: '',
      phone: '',
      location: '',
      propertyType: '',
      priceExpectation: '',
      message: ''
    }
  } catch (error) {
    console.error(error)

    if (error.response) {
      this.errorMessage = JSON.stringify(error.response.data)
    } else {
      this.errorMessage = error.message
    }
  } finally {
    this.sending = false
  }
}
  }
}
</script>

<style scoped>
.sell-image-card {
  border: 1px solid #e5ecf5;
  border-radius: 0;
  overflow: hidden;
  background: #fff;
}

.sell-image-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sell-form .form-control,
.sell-form .form-select {
  border-radius: 0 !important;
}

.sell-form textarea.form-control {
  resize: vertical;
}

.btn-brand {
  border-radius: 0 !important;
  background: var(--brand-red);
  border-color: var(--brand-red);
  color: #fff;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .04em;
  padding: .7rem 1.15rem;
}

.btn-brand:hover {
  background: var(--brand-red);
  color: #fff;
  border-color: #fff;
}
</style>